import { Input as ChakraInput } from "@chakra-ui/react";
import type { ReactNode } from "react";
import styled from "styled-components";
import { colors } from "@permisso/permisso-components";

type ActorAccessEmailFieldProps = {
  id: string;
  email: string;
  label: ReactNode;
  placeholder: string;
  errorMessage?: ReactNode;
  dataTestId?: string;
  onEmailChange: (email: string) => void;
};

export const ActorAccessEmailField = ({
  id,
  email,
  label,
  placeholder,
  errorMessage,
  dataTestId,
  onEmailChange,
}: ActorAccessEmailFieldProps) => (
  <FieldContainer>
    <LabelRow>
      <FieldLabel htmlFor={id}>{label}</FieldLabel>
      <RequiredMark aria-hidden="true">*</RequiredMark>
    </LabelRow>
    <StyledInput
      id={id}
      data-testid={dataTestId}
      value={email}
      onChange={(event) => onEmailChange(event.target.value)}
      placeholder={placeholder}
      isInvalid={Boolean(errorMessage)}
    />
    {errorMessage ? <ErrorText>{errorMessage}</ErrorText> : null}
  </FieldContainer>
);

const FieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0 0.25rem;
`;

const LabelRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
`;

const FieldLabel = styled.label`
  color: ${colors.grey800};
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
`;

const RequiredMark = styled.span`
  color: #e44359;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.5;
`;

const StyledInput = styled(ChakraInput)`
  height: 2.5rem !important;
  border-radius: 0.5rem !important;
  border-color: ${colors.grey500} !important;
  padding: 0.25rem 0.5rem !important;
  font-size: 0.875rem;
  color: ${colors.grey800};

  &::placeholder {
    color: ${colors.grey500};
  }

  &:hover,
  &:focus-visible,
  &:focus {
    border-color: ${colors.grey500} !important;
    box-shadow: none !important;
  }
`;

const ErrorText = styled.span`
  color: ${colors.darkRed};
  font-size: 0.875rem;
  line-height: 1.5;
`;
